import Api from './Api'
export default {
    userLogin(login, password) {
        const data = new FormData();
        data.append('name', login);
        data.append('password', password);
        return Api().post('/user/login', data)
    },
    userRegister(name, first_name, last_name, street_name, house_number, password, email, phone) {
        const data = new FormData();
        data.append('name', name);
        data.append('first_name', first_name);
        data.append('last_name', last_name);
        data.append('street_name', street_name);
        data.append('house_number', house_number);
        data.append('password', password);
        data.append('email', email);
        data.append('phone', phone);
        return Api().post('/user/register', data)
    },
    userProfile() {
        return Api().get('/user')
    },
    userProfileUpdate(name, first_name, last_name, street_name, house_number, email, image, phone) {
        const data = new FormData();
        data.append('name', name);
        data.append('first_name', first_name);
        data.append('last_name', last_name);
        data.append('street_name', street_name);
        data.append('house_number', house_number);
        data.append('email', email);
        data.append('profile_pic', image);
        data.append('phone', phone);
        return Api().post('/user/update', data)
    },
    deletePhoto() {
        return Api().delete(`/user/profilePic`)
    },
    logout() {
        return Api().get('/user/logout')
    },
    allGateType() {
        return Api().get('/committee/gate')
    },
    getGateStreet(id) {
        return Api().get('/committee/street/' + id)
    }

}